import React from 'react';
import { Icon, Input, InputProps, theme } from 'components';
import styled from 'styled-components';

const Searchbar: React.FC<InputProps> = ({ value, onChange, ...props }) => (
  <StyledInput
    allowClear
    placeholder="Search Users"
    value={value}
    onChange={onChange}
    {...props}
    suffix={<Icon type="search" color="gray5" />}
  />
);

export default Searchbar;

const StyledInput = styled(Input)`
  & > span,
  & > span > input {
    background-color: ${theme.white};
  }
  border: 2px solid ${theme.gray5};
  border-radius: ${theme.getBorderRadius('small')};
`;
